export const backendUrl = import.meta.env.VITE_BACKEND_URL;
// export const DEBUG = import.meta.env.VITE_DEBUG === 'true';
export const DEBUG = false;
export const ENABLE_LOGGING = import.meta.env.VITE_ENABLE_LOGGING === "true";
export const FACEBOOK_APP_ID = "937522511109972";
export const ANDROID_DOWNLOAD_LINK = "https://play.google.com/store/apps/details?id=us.inyc.app";
export const IOS_DOWNLOAD_LINK = "https://apps.apple.com/us/app/in-yc/id6473464078";

// OAuth Client IDs
export const OAUTH_GOOGLE_IOS_CLIENT_ID = "8773442283-k8agbo4m11ddfbnfu2m07urj3tcasvft.apps.googleusercontent.com";
export const OAUTH_GOOGLE_ANDROID_CLIENT_ID = "8773442283-c9lr2dv80g3k83lanq4amu64e8cteemf.apps.googleusercontent.com"; // Replace with your Android OAuth Client ID
export const OAUTH_GOOGLE_WEB_CLIENT_ID = "8773442283-9redmu88ro71ciav6gd3ofn118s3eah5.apps.googleusercontent.com"; // Fallback for web

export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return "unknown";
}

export const version = "2.4.7";

/**
 * Get the correct Google OAuth Client ID based on current platform
 * @param {Object} Capacitor - Capacitor object
 * @returns {string} Platform-specific Google OAuth Client ID
 */
export function getGoogleClientId(Capacitor) {
  if (!Capacitor) {
    console.warn('[OAuth] Capacitor not available, using web client ID');
    return OAUTH_GOOGLE_WEB_CLIENT_ID;
  }

  const platform = Capacitor.getPlatform();
  
  switch (platform) {
    case 'ios':
      console.log('[OAuth] Using iOS Client ID');
      return OAUTH_GOOGLE_IOS_CLIENT_ID;
    
    case 'android':
      console.log('[OAuth] Using Android Client ID');
      return OAUTH_GOOGLE_ANDROID_CLIENT_ID;
    
    default:
      console.log('[OAuth] Using Web Client ID (platform:', platform, ')');
      return OAUTH_GOOGLE_WEB_CLIENT_ID;
  }
}
